class SiteElementHover
    extends QueryElement<HTMLElement> {

    private _isActive: boolean;


    constructor(element: HTMLElement) {
        super(element, false);

        this._isActive = false;
        
        this.query(".element-hover-close").all((a) => {
            a.on("click", () => {
                this.click();
            })
        });

        this.on("mouseenter", () => {
            this.hover(true);
        });
        this.on("mouseleave", () => {
            this.unhover(true);
        });
    }

    click() {
        if (this._isActive)
            return;
        
        if (this.containsClass("hover"))
            this.unhover();
        else
            this.hover();
    }

    hover(force = false) {
        if (this._isActive && !force)
            return;

        this.addClass("hover");
        this.action();
    }
    unhover(force = false) {
        if (this._isActive && !force)
            return;

        this.removeClass("hover");
        this.action();
    }

    action() {
        this._isActive = true;
        setTimeout(() => {
            this._isActive = false;
        }, 100);
    }
}